import React, { useState } from "react";
import Slider from "react-slick";
import renderHTML from "react-render-html";
import {
  UncontrolledButtonDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
} from "reactstrap";
import MagicSliderDots from "react-magic-slider-dots";
import "react-magic-slider-dots/dist/magic-dots.css";
import "react-multi-carousel/lib/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "react-modal-video/css/modal-video.css";
import Config from "../../Config.js";
import { NumericFormat } from "react-number-format";
import { VideoTag } from "react-video-tag";
import Productdetailsfooter from "../productdetail/productdetailsfooter.js";


const Theme = ({
  titlefontsize,
  descriptionfontsize,
  ckeditorTitleFontSize,
  ckeditorDescriptionFontSize,
  color1,
  color2,
  color3,
  isBackgroundUrl,
  Productinfo,
  onClickCollapse,
  selectcollapseidlist,
  sliderimground,
  LogoshadowFinal,
  Iscertificatesopen,
  IscertificatesClick,
  uploadBackgroundImage,
}) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    appendDots: (dots) => {
      return <MagicSliderDots dots={dots} numDotsToShow={3} dotWidth={30} />;
    },
  };
  const settings2 = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2.3,
    slidesToScroll: 1,
    arrows: false,
  };

  const reyurnperamiter = (item) => {
    let itemobj = item.split("https://www.youtube.com/watch");
    return new URLSearchParams(itemobj[1]).get("v");
  };



  return (
    <div
      className=""
      style={{
        position: "relative",
        minHeight: "100vh",
        backgroundPosition: "center",
        backgroundAttachment: "fixed",
        backgroundSize: "cover",
        backgroundColor: isBackgroundUrl == false ? color2 : "",
        backgroundImage:
          uploadBackgroundImage && isBackgroundUrl == true
            ? `url(${color2})`
            : `url(${Config.contentUrl + color2})`,
      }}
    >
      <div className="padding-30">
        <div
          className="container detailpageheader"
          style={{ backgroundColor: color1 }}
        >
          <div className="row align-items-center px-2">
            <h4 className="col-xs-6 mb-0" style={{ color: color3 }}>
              Scan To Tell
            </h4>
            <div className="col-xs-6 d-flex align-items-end justify-content-end">
              <img
                alt=""
                src="../assets/img/logo/STT-Logo.png"
                className="sttlogo"
              />
            </div>
          </div>
        </div>

        <div className="container-fluid mt-1">
          <div className="row ">
            <div className="col-md-12 slider-mobileview mt-1">
              <Slider {...settings} className="slider mt-5 pt-4">
                {Productinfo?.articleImage.map((item, i) => {
                  return (
                    <div>
                      <img
                        alt=""
                        src={Config.contentUrl + item.filePath}
                        className="sliderImage img-fluid"
                        style={{ borderRadius: "15px" }}
                      />
                    </div>
                  );
                })}
              </Slider>
              <UncontrolledButtonDropdown className="positionbutton ">
                <DropdownToggle
                  className="btn btn-white change-hight rounded-circle shadow-add  border-0"
                  style={{ backgroundColor: color1, color: color3 }}
                >
                  <i class="fa fa-ellipsis-v fa-lg" aria-hidden="true"></i>
                </DropdownToggle>
                <DropdownMenu className="DropdownMenu">
                  <DropdownItem className="item">
                    <i class="ion ion-md-wallet fa-2x text-success "></i>
                  </DropdownItem>
                  <DropdownItem className="item">
                    <i class="ion ion-md-share fa-2x text-gray "></i>
                  </DropdownItem>
                  <DropdownItem className="item">
                    <i
                      class="fas fa-qrcode iconheight"
                      style={{
                        fontSize: "22px",
                        color: "#000",
                      }}
                    ></i>
                  </DropdownItem>

                  <DropdownItem className="item">
                    <i
                      class="ion ion-md-list-box"
                      style={{
                        fontSize: "22px",
                        color: "rgb(87, 134, 252)",
                      }}
                    ></i>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
          </div>
        </div>

        <div className="container-fluid mt-1 mb-2">
          <div className="row align-items-center">
            <div className="col-xs-8">
              <h2
                className="mb-1 text-black1"
                style={{ fontSize: "24px", color: color3 }}
              >
                {Productinfo?.articleName ? Productinfo?.articleName : ""}
              </h2>

              <div className="row relatedspantag-main">
                {
                  Productinfo?.sellPrice && Productinfo?.sellPrice !== "0" && Productinfo?.sellPrice !== 0 ?
                    <>
                      <p
                        className="relatedspantag  text-decoration-line-through mr-2"
                        style={{ color: color3 }}
                      >
                        {Productinfo?.currencyDetail?.otherName}
                        {Productinfo?.regularPrice}
                      </p>
                      <p className="relatedspantag text-red ">
                        {Productinfo?.currencyDetail?.otherName}
                        {Productinfo?.sellPrice}
                      </p>
                    </>
                    : <>
                      <p
                        className="relatedspantag mr-2"
                        style={{ color: color3 }}
                      >
                        {Productinfo?.currencyDetail?.otherName}
                        {Productinfo?.regularPrice}
                      </p>
                    </>
                }
              </div>
            </div>
            <div className=" col-xs-4 text-right">
              <button className="btn btn-link">
                {Productinfo?.productLogoPath ? (
                  <img
                    alt=""
                    src={Config.contentUrl + Productinfo?.productLogoPath}
                    className="width-70 height-70 f-s-20 text-center rounded shadow"
                  />
                ) : (
                  <img
                    alt=""
                    src={Config.contentUrlApi + "Frontend/images.png"}
                    className="width-70 height-70 f-s-20 text-center rounded "
                  />
                )}
              </button>
            </div>
          </div>
        </div>
        {Productinfo?.isArticleTypeDisplay ? (
          <div className="container-fluid mobile-view-default-select2" style={{marginLeft:'10px', width:'94%'}}>
            <div className="row">
              <label className="col-form-label">Select Combination </label>
              <select className="default-select2 form-control">
                <option value="0" selected>
                  --- Select Combination ---
                </option>{" "}
                {Productinfo?.attributeValueMappingList.map((item) => {
                  return item.attributeValue1 != "" &&
                    item.attributeValue2 != "" &&
                    item.attributeValue3 != "" &&
                    item.attributeValue4 != "" &&
                    item.attributeValue5 != "" ? (
                    <option value={item._id}>
                      {item.attributeValue1 +
                        " / " +
                        item.attributeValue2 +
                        " / " +
                        item.attributeValue3 +
                        " / " +
                        item.attributeValue4 +
                        " / " +
                        item.attributeValue5}
                    </option>
                  ) : item.attributeValue1 != "" &&
                    item.attributeValue2 != "" &&
                    item.attributeValue3 != "" &&
                    item.attributeValue4 != "" &&
                    item.attributeValue5 === "" ? (
                    <option value={item._id}>
                      {item.attributeValue1 +
                        " / " +
                        item.attributeValue2 +
                        " / " +
                        item.attributeValue3 +
                        " / " +
                        item.attributeValue4}
                    </option>
                  ) : item.attributeValue1 != "" &&
                    item.attributeValue2 != "" &&
                    item.attributeValue3 != "" &&
                    item.attributeValue4 === "" &&
                    item.attributeValue5 === "" ? (
                    <option value={item._id}>
                      {item.attributeValue1 +
                        " / " +
                        item.attributeValue2 +
                        " / " +
                        item.attributeValue3}
                    </option>
                  ) : item.attributeValue1 != "" &&
                    item.attributeValue2 != "" &&
                    item.attributeValue3 === "" &&
                    item.attributeValue4 === "" &&
                    item.attributeValue5 === "" ? (
                    <option value={item._id}>
                      {item.attributeValue1 + " / " + item.attributeValue2}
                    </option>
                  ) : item.attributeValue1 != "" &&
                    item.attributeValue2 === "" &&
                    item.attributeValue3 === "" &&
                    item.attributeValue4 === "" &&
                    item.attributeValue5 === "" ? (
                    <option value={item._id}>{item.attributeValue1}</option>
                  ) : (
                    <></>
                  );
                })}
              </select>
            </div>
          </div>
        ) : (
          <></>
        )}

        {Productinfo?.isArticleDescriptionDisplay && Productinfo?.shortDescription != null && Productinfo?.shortDescription !== "" && Productinfo?.shortDescription != undefined? (
          <div className="container-fluid mb-3">
            <div className="row mt-4">
              <div className="col-md-12">
                <div
                  className="ckeditor-text card ckeditor-theme"
                  style={{
                    borderWidth: "4px",
                    borderColor: color1 ? color1 : "",
                    backgroundColor: "white",
                 
                  }}
                >
                  <div
                    className="ckeditor-text-new"
                    style={{
                      overflowX: "scroll",
                      padding: "15px",
                      // fontSize: descriptionfontsize ? descriptionfontsize : "",
                      backgroundColor: "transparent",
                      borderWidth: "4px",
                      borderColor: color1 ? color1 : "",
                    }}
                  >
                    {Productinfo?.shortDescription ? (
                      renderHTML(Productinfo?.shortDescription)
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        {Productinfo?.isArticleDescriptionDisplay &&
          Productinfo?.aarticleProductSegment?.map((Item, i) => {
            return (
              <div className="container-fluid ">
                {Item?.articleSegmentImageList.length > 0 ||
                  Item?.articleVideoList.length > 0 ||
                  Item?.articleDocumentList.length > 0 ||
                  Item?.articleExternalLinkList.length > 0 ||
                  Item?.description?.length > 0 ? (
                  <div className="row">
                    <div className="col-xl-12">
                      <button
                        className="btn btn-white collapsebutton collapseshadow mt-2 "
                        type="button"
                        style={{ backgroundColor: color1 }}
                        onClick={() => {
                          onClickCollapse(Item?._id);
                        }}
                      >
                        <p
                          className="mb-0 maincollapse text-break"
                          style={{ color: color3 }}
                        >
                          {Item?.title}
                        </p>
                        {selectcollapseidlist != null &&
                          selectcollapseidlist?.includes(Item?._id) == true ? (
                          <i
                            className="fas fa-lg fa-fw me-10px  fa-angle-up"
                            style={{ color: color3 }}
                          ></i>
                        ) : (
                          <i
                            className="fas fa-lg fa-fw me-10px fa-angle-down"
                            style={{ color: color3 }}
                          ></i>
                        )}
                      </button>
                      <Collapse
                        isOpen={
                          selectcollapseidlist != null
                            ? selectcollapseidlist?.includes(Item?._id)
                            : false
                        }
                      >
                        <div
                          //className="collapse"
                          id={"collapseExample_" + Item?._id}
                        >
                          {Item?.articleSegmentImageList != null &&
                            Item?.articleSegmentImageList?.length > 0 ? (
                            <div className="row mt-4 ">
                              <div className="col-md-12">
                                <Slider {...settings} className="subslider">
                                  {Item?.articleSegmentImageList ? (
                                    Item?.articleSegmentImageList?.map(
                                      (subItem, i) => {
                                        return (
                                          <div>
                                            <img
                                              alt=""
                                              src={
                                                Config.contentUrl +
                                                subItem.filePath
                                              }
                                              className="sliderImage"
                                            />
                                          </div>
                                        );
                                      }
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </Slider>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}
                          {Item?.description != null &&
                            Item?.description != "" &&
                            Item?.description != undefined ? (
                            <div
                              className="container-fluid mt-2 card ckeditor-theme"
                              style={{
                                overflowX: "scroll",
                                backgroundColor: "white",
                                borderWidth: "4px",
                                borderColor: color1 ? color1 : "",
                              
                              }}
                            >
                              {/* <div className="container-fluid mt-2 card"> */}
                              <div className="row mt-4">
                                <p className="col-md-12 text-break">
                                  <div
                                    className="ckeditor-text-new "
                                    style={{
                                      overflowX: "scroll",
                                      fontSize: ckeditorTitleFontSize,
                                      background: "transparent",
                                    }}
                                  >
                                    {Item?.description != null &&
                                      Item?.description != "" &&
                                      Item?.description != undefined ? (
                                      renderHTML(Item?.description)
                                    ) : (
                                      <></>
                                    )}
                                  </div>
                                </p>
                              </div>
                            </div>
                          ) : (
                            <></>
                          )}

                          <div className="container-fluid px-0">
                            <div className="row px-1">
                              {Item.articleVideoList.length > 0 &&
                                Item.isArticleSegmentVideoDisplay === true ? (
                                <div
                                  className="col-md-12 mt-2 transparent-ckeditor-theme"
                                  style={{
                
                                    overflowX: "scroll",
                                    background: "transparent",
                                  }}
                                >
                                  <div
                                    className={"collapse subsection  show"}
                                    id={"detailknowmore" + Item._id}
                                  >
                                    <div className="row mt-4">
                                      {Item.articleVideoList.length > 0
                                        ? Item.articleVideoList.map((subItem) =>
                                          subItem.isYouTubeLink === false ? (
                                            <>
                                              <div className="col-xs-6 text-center">
                                                <button className="btn btn-link p-0 videotag bg-transparent">
                                                  <VideoTag
                                                    src={
                                                      Config.contentUrl +
                                                      subItem.filePath
                                                    }
                                                    className="image-article imageUploaddetailpage"
                                                  />
                                                  <p className="videotagtext text2line breakword">
                                                    {subItem.originalFileName}
                                                  </p>

                                                  <div className="youtubeicon">
                                                    <i className="fab fa-lg fa-fw fa-youtube"></i>
                                                  </div>
                                                </button>
                                              </div>
                                            </>
                                          ) : (
                                            <>
                                              <div className="col-xs-6 text-center">
                                                <button className="btn btn-link p-0 videotag bg-transparent">
                                                  <img
                                                    src={`https://i.ytimg.com/vi/${reyurnperamiter(
                                                      subItem?.youTubeLink
                                                    )}/hqdefault.jpg`}
                                                    className="image-article imageUploaddetailpage"
                                                  />
                                                  <p className="videotagtext text2line breakword">
                                                    {subItem.youTubeLink}
                                                  </p>

                                                  <div className="youtubeicon">
                                                    <i className="fab fa-lg fa-fw fa-youtube"></i>
                                                  </div>
                                                </button>
                                              </div>
                                            </>
                                          )
                                        )
                                        : null}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                              {Item.articleDocumentList.length > 0 &&
                                Item.isArticleSegmentDocumentDisplay === true ? (
                                <div
                                  className="col-md-12 mt-2 transparent-ckeditor-theme"
                                  style={{
                                    
                                   
                                    
                                    overflowX: "scroll",
                                    background: "transparent",
                                  }}
                                >
                                  <div
                                    className={"collapse subsection show "}
                                    id={"detailreadfurther" + Item._id}
                                  >
                                    <div className="row mt-4">
                                      {Item.articleDocumentList.length > 0
                                        ? Item.articleDocumentList.map(
                                          (subItem) => {
                                            return (
                                              <div className="col-xs-6 text-center">
                                                <button className="btn btn-white image-button collapseshadow">
                                                  <img
                                                    alt=""
                                                    src={
                                                      Config.contentUrlApi +
                                                      "Frontend/pdf.png"
                                                    }
                                                    className="pdfimages"
                                                  />
                                                </button>
                                                <div className="row">
                                                  <h5 className="mt-2 col-md-12 wordbreak text2line">
                                                    {subItem.originalFileName}
                                                  </h5>
                                                </div>
                                              </div>
                                            );
                                          }
                                        )
                                        : null}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                              {Item.articleExternalLinkList.length > 0 &&
                                Item.isArticleSegmentWebLinkDisplay === true ? (
                                // <div className="col-md-12 mt-2 card" style={{ backgroundColor: color1, height: "280px", overflowX: 'scroll', }}>
                                <div className="col-md-12 mt-2">
                                  <div
                                    className={"collapse subsection  show"}
                                    id={"detailexplorefurther" + Item._id}
                                  >
                                    <div className="row">
                                      {Item.articleExternalLinkList.length > 0
                                        ? Item.articleExternalLinkList.map(
                                          (subItem) => {
                                            return (
                                              <div className="col-xs-12 d-flex justify-content-center mt-2">
                                                <div className="linkmain-btn p-3">
                                                  {subItem.name ? (
                                                    // <a className="" href={subItem?.linkURL} style={{ color: 'black', fontSize: '18px' }}>
                                                    <a
                                                      className=""
                                                      href={
                                                        "javascript:void(0)"
                                                      }
                                                      style={{
                                                        color: "black",
                                                        fontSize: "18px",
                                                      }}
                                                    >
                                                      {" "}
                                                      {subItem?.name}
                                                    </a>
                                                  ) : (
                                                    <></>
                                                  )}

                                                  {/* <button
                                                  className="btn btn-link weblinkbuton"
                                                  type="button"
                                                >
                                                  <p className="mb-0 exploreweblink text2line">
                                                    {
                                                      subItem.linkURL
                                                    }
                                                  </p>
                                                
                                                </button> */}
                                                </div>
                                              </div>
                                            );
                                          }
                                        )
                                        : null}
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            );
          })}
        {Productinfo?.isCertificateDisplay &&
          Productinfo?.certificateDetail?.length > 0 ? (
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12 mt-2">
                <button
                  className="btn btn-white collapsebutton collapseshadow"
                  type="button"
                  data-toggle="collapse"
                  data-target="#certificates"
                  aria-expanded="false"
                  aria-controls="certificates"
                  style={{ backgroundColor: color1 }}
                  onClick={() => {
                    IscertificatesClick();
                  }}
                >
                  <p className="mb-0 maincollapse" style={{ color: color3 }}>
                    Certificates
                  </p>
                  {Iscertificatesopen == true ? (
                    <i
                      className="fas fa-lg fa-fw me-10px  fa-angle-up"
                      style={{ color: color3 }}
                    ></i>
                  ) : (
                    <i
                      className="fas fa-lg fa-fw me-10px fa-angle-down"
                      style={{ color: color3 }}
                    ></i>
                  )}
                </button>
                <Collapse isOpen={Iscertificatesopen}>
                  <div className="subsection" id="certificates">
                    <div className="row ">
                      {Productinfo?.certificateDetail?.length > 0
                        ? Productinfo?.certificateDetail?.map((Item, i) => {
                          return (
                            <>
                              {" "}
                              <div className="col-xs-6 text-center mt-3">
                                <button className="btn btn-white image-button collapseshadow">
                                  <img
                                    alt=""
                                    src={Config.contentUrl + Item._LogoPath}
                                    onError={({ currentTarget }) => {
                                      currentTarget.onerror = null; // prevents looping
                                      currentTarget.src =
                                        "../assets/img/new-images/images.png";
                                    }}
                                  />
                                </button>
                                <div className="row">
                                  <h5 className="mt-2 col-md-12 wordbreak">
                                    {Item.name}
                                  </h5>
                                </div>
                              </div>
                            </>
                          );
                        })
                        : null}
                    </div>
                  </div>
                </Collapse>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        {Productinfo?.relatedproduct != null &&
          Productinfo?.isRelatedProductDisplay &&
          Productinfo?.relatedproduct?.length > 0 ? (
          <div className="container-fluid mt-2">
            <Slider {...settings2} className="reletedprodslider">
              {Productinfo?.relatedproduct.map((Item, i) => {
                return (
                  <button
                    className="btn"
                    style={{ backgroundColor: "transparent" }}
                  >
                    <img
                      alt=""
                      src={Config.contentUrl + Item.relatedproductImage}
                      className="sliderImage"
                      onError={({ currentTarget }) => {
                        currentTarget.onerror = null; // prevents looping
                        currentTarget.src =
                          "../assets/img/new-images/images.png";
                      }}
                    />

                    <h5 className="mb-0 text-left mt-3">
                      {Item.relatedproductName}
                    </h5>
                  </button>
                );
              })}
            </Slider>
          </div>
        ) : (
          <></>
        )}
        {Productinfo?.isArticleChatDisplay ? (
          <div className="container-fluid mt-3">
            <div className="row justify-content-center pb-3">
              <button
                type="button"
                class="btn btn-success me-1 mb-1 shadow-add border-0"
                style={{
                  backgroundColor: color1,
                  color: color3
                }}
              >
                Click to Connect now!
              </button>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      <Productdetailsfooter
        onClick={(e) => {
          //setmodalReportabuse(true)
        }}

      ></Productdetailsfooter>


    </div>
  );
};

export default Theme;
